
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { InventoryItemListItem } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import { formatDateWithTime, formatBool } from "@/utils";
import permissions from "@/security/permissions";

const inventoryModuleState = getModule(InventoryModule);

@Component
export default class PalletItemTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get palletItems(): Array<InventoryItemListItem> {
    return inventoryModuleState.palletItemsData;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedPalletItemCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedPalletItems;
  }

  get totalItems() {
    if (inventoryModuleState.palletItemsData) {
      return inventoryModuleState.palletItemsData.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
    if(this.hasPermission(permissions.barcodeSystem.inventory.view))
      inventoryModuleState.viewInventoryItemShortcutAction({selectedItems: [data]});
  }

  onRowClick(data) {
    this.unselectAll();
    inventoryModuleState.switchPalletItemSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      inventoryModuleState.switchPalletItemSelectionStatus(item.id);
    });
  }
}
